import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { Checkbox, Dropdown, Form, Input } from "semantic-ui-react";

import { DBB_MANDATORY_CUSTOMER_FIELDS, getCustomerOrCompanyName, hasContractCustomerName } from "./../../utils";

export const CUSTOMER_ROLES = [
  { role: "driver", label: "driver", defaultText: "Driver" },
  { role: "owner", label: "owner", defaultText: "Owner" },
  { role: "contract", label: "contractor", defaultText: "Contractor" },
];

class DBBCustomerSection extends Component {
  getCustomerRoleOptions = () => {
    const { customers, t } = this.props;

    return CUSTOMER_ROLES.reduce((options, { role, label, defaultText }) => {
      const customer = customers?.[role];
      if (customer) options.push({ key: role, value: role, text: getCustomerOrCompanyName(customer), description: t(label).message || defaultText });

      return options;
    }, []);
  };

  isMandatory = field => DBB_MANDATORY_CUSTOMER_FIELDS.includes(field);

  hasMandatoryError = field => this.props.hasValidationError && this.isMandatory(field) && !this.props.customer?.[field];

  renderField = (field, label, defaultText, width) => (
    <Form.Field width={width} required={this.isMandatory(field)} error={this.hasMandatoryError(field)}>
      <label>{this.props.t(label).message || defaultText}</label>
      <Input
        value={this.props.customer?.[field] || ""}
        placeholder={this.props.t(label).message || defaultText}
        onChange={(_e, { value }) => this.props.onChangeField(field, value)}
      />
    </Form.Field>
  );

  render() {
    const { customer, isUnknown, hasValidationError, onChangeRole, onToggleUnknown, t } = this.props;

    const hasNameError = hasValidationError && !hasContractCustomerName(customer);
    const isCompanyRequired = !customer?.name?.trim();
    const isNameRequired = !customer?.company?.trim();

    return (
      <div className="customer-section">
        <Form.Field>
          <Checkbox label={t("unknown").message || "Unknown"} checked={!!isUnknown} onChange={onToggleUnknown} />
        </Form.Field>

        {!isUnknown && (
          <>
            <Form.Group>
              <Form.Field width={8}>
                <label>{t("claire_customer_type").message || "Claire Customer type"}</label>
                <Dropdown
                  selection
                  fluid
                  selectOnBlur={false}
                  placeholder={t("customer_type").message || "Customer type"}
                  options={this.getCustomerRoleOptions()}
                  value={customer?.role || null}
                  onChange={(_e, { value }) => onChangeRole(value)}
                />
              </Form.Field>
              <Form.Field width={8} required={isCompanyRequired} error={hasNameError}>
                <label>{t("company").message || "Company"}</label>
                <Input
                  value={customer?.company || ""}
                  placeholder={t("company").message || "Company"}
                  onChange={(_e, { value }) => this.props.onChangeField("company", value)}
                />
              </Form.Field>
            </Form.Group>
            <Form.Group>
              <Form.Field width={8}>
                <label>{t("initials").message || "Initials"}</label>
                <Input
                  value={customer?.initials || ""}
                  placeholder={t("initials").message || "Initials"}
                  onChange={(_e, { value }) => this.props.onChangeField("initials", value)}
                />
              </Form.Field>
              <Form.Field width={8} required={isNameRequired} error={hasNameError}>
                <label>{t("name").message || "Name"}</label>
                <Input value={customer?.name || ""} placeholder={t("name").message || "Name"} onChange={(_e, { value }) => this.props.onChangeField("name", value)} />
              </Form.Field>
            </Form.Group>
            <Form.Group>
              {this.renderField("street", "street", "Street", 8)}
              {this.renderField("number", "number", "Number", 8)}
            </Form.Group>
            <Form.Group>
              {this.renderField("postcode", "postcode", "Postcode", 8)}
              {this.renderField("place", "city", "City", 8)}
            </Form.Group>
            <Form.Group>
              {this.renderField("email_business", "email", "Email", 6)}
              {this.renderField("tel_mobile_business", "mobile", "Mobile", 6)}
              {this.renderField("tel_business_nr", "phone", "Phone", 6)}
            </Form.Group>
          </>
        )}
      </div>
    );
  }
}

export default withTranslation()(DBBCustomerSection);
